export default "__VITE_ASSET__zc86utHh__"